<ng-container *ngIf="showOrderFlowHeader()">

    <app-order-flow-header></app-order-flow-header>

    <!-- Dialogs -->
    <app-auth-dialogs></app-auth-dialogs>

</ng-container>

<ng-container *ngIf="!showOrderFlowHeader()">

    <!-- Desktop -->
    <div class="desktop-menu-enabled">
        <div id="layoutHeader" class="layout-topbar topbar-content">
            <div class="container">
                <div class="d-flex">
                    <div class="d-flex justify-content-start align-items-center pe-5">            
                        <img class="d-flex justify-content-start" src="assets/images/Logo.png" (click)="goToHome()" id="logoHeader" />
                    </div>
                    
                    <div id="menu-items-links" class="d-flex justify-content-center align-items-center w-100">
                        <ul class="horizontal-menu">
                            <li *ngFor="let item of items" [class.selected]="selectedItem === item.url"
                                (click)="onItemClick(item)">
                                <a *ngIf="item.url !== 'login'">
                                    {{ item.label }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    
                    <div class="d-flex justify-content-end align-items-center">
                        <a href="/order-flow" class="btn-order">Order Now</a>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

    <!-- Tablet And Mobile -->
    <p-sidebar [(visible)]="sidebarVisible" styleClass="w-100 " [blockScroll]="true" class="overlay-mobile-menu">
        <ng-template pTemplate="content" style="opacity: 0.5 !important;">
            <div class="row h-100">
                <div class="col-6">
                    <ul class="mobile-menu">
                        <li *ngFor="let item of items_mobile" [class.selected]="selectedItem === item.url"
                            (click)="onItemClick(item)" style="list-style-type: none; cursor: pointer;">
                            <a class="fs-paragraph--medium" style="margin-top: 20px;" *ngIf="item.url !== 'login'">
                                {{ item.label }}
                            </a>
                        </li>
                        <li style="list-style-type: none; cursor: pointer;" *ngIf="isLogin">
                            <p-divider class="flex-grow-4"></p-divider>
                            <a class="mobile-usr-profile-btn" (click)="goToProfile()">
                                My Account
                            </a>
                        </li>

                        <li style="list-style-type: none; cursor: pointer;" *ngIf="isLogin">
                            <a class="mobile-usr-profile-btn" (click)="goToMyOrders()">
                                My Orders
                            </a>
                        </li>

                        <li style="list-style-type: none; cursor: pointer;">
                            <p-divider class="flex-grow-4" *ngIf="!isLogin"></p-divider>
                            <a class="mobile-login-btn" *ngIf="!isLogin" (click)="loginPopupManager()">
                                Login
                            </a>
                            <a class="mobile-logout-btn" *ngIf="isLogin" (click)="logout()">
                                Logout
                            </a>
                        </li>

                    </ul>
                </div>
                <div class="col-6 mobile-menu-box">
                    <img class="d-block " src="assets/images/Dish-right.png">
                </div>

            </div>
        </ng-template>
    </p-sidebar>

    <div class="mobile-menu-enabled">
        <div id="layoutHeader" class="mobile-menu-container topbar topbar-content">
            <div>
                <p-button styleClass="p-button-rounded p-button-secondary p-button-text p-button-lg" (click)="sidebarVisible = true">
                    <img src="assets/images/menu-01.png" style="object-fit: contain;" />
                </p-button>
            </div>
            <div>
                <img src="assets/images/Logo.png" style="height: 2rem;width: 13.326rem;object-fit: contain;" (click)="goToHome()"/>
            </div>
            
            <div class="d-flex" style="margin-right: 10px;">
                <a href="/order-flow" class="btn-order">Order Now</a>
            </div>
            
        </div>
    </div>

    <!-- Dialogs -->
    <app-auth-dialogs></app-auth-dialogs>

</ng-container>